
import React, { FC, useState } from "react";
import styles from "../ImageGalleryMain.module.css";
import classnames from "classnames";
import { ImageGallery } from "components";

type ImageGalleryMainItemProps = {
  Alt: string;
  Src?: string;
  backgroundItem?: any;
};

type TImageGalleryMainProps = {
  large?: boolean;
  small?: boolean;
  images: ImageGalleryMainItemProps[];
  className?: string;
  width?: string;
  height?: string;
  noArrows?: boolean;
  ShowCaptions: boolean;
};

const _ImageGalleryMainMobile: FC<TImageGalleryMainProps> = ({
  noArrows,
  large,
  small,
  images,
  ShowCaptions = true
}) => {
  const [ready, setReady] = useState<boolean>(true);

  return (
    <section style={{ opacity: ready ? 1 : 0, width: '100vw', marginLeft: '-7.5vw' }}>
      <div
        className={classnames(styles.wrapper, { large: large, small: small }, 'ImageGalleryMain', { noArrows: noArrows })}
      >
        <ImageGallery noCaption={!ShowCaptions} fullscreen images={images} />
      </div>
    </section>
  );
};

export const ImageGalleryMainMobile = React.memo(_ImageGalleryMainMobile);
